import Text from '../../Text'
import { Container } from '../Container'

function Texts() {
  return (
    <Container label='Text'>
      <Text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore...
      </Text>
    </Container>
  )
}

export default Texts
